import { useState } from 'react';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { useAdminPreview } from '@/lib/admin-preview-context';

// map themes to a list of related questions
export const CARDS = [
  {
    name: 'Aarding',
    questions: [
      'Hoe voel jij je verbonden met de Aarde?',
      'Wat geeft jou stabiliteit en zekerheid?',
      'Op welke plek voel jij je het meest thuis?',
      'Hoe kan jij jezelf gronden wanneer je je overweldigd voelt?',
      'Wat helpt jou om weer met beide benen op de grond te staan?',
    ],
  },
  {
    name: 'Balans',
    questions: [
      'Wat helpt jou in balans te blijven?',
      'Hoe vind jij je evenwicht?',
      'Waarin mag jij vandaag extra jouw grenzen bewaken? En hoe ga je dat doen?',
      'Hoe merk jij dat je uit balans bent? • Fysiek • Mentaal • Emotioneel • Energetisch',
      'Wat doe jij om werk en privé in evenwicht te houden?',
    ],
  },
  {
    name: 'Dankbaarheid',
    questions: [
      'Waar ben jij dankbaar voor? • Persoonlijk • Gezin • Werk',
      'Op welke momenten voelde jij je vandaag dankbaar?',
      "Voor welke collega's ben jij dankbaar?",
      'Welke kleine dingen in je werk geven je een gevoel van dankbaarheid?',
      'Hoe kun jij dankbaarheid vaker bewust ervaren?',
    ],
  },
  {
    name: 'Energie',
    questions: [
      'Wat heeft jou vandaag energie gegeven?',
      'Welke activiteit of bezigheid laadt jou op?',
      'Waaraan voel/herken jij dat je energie nodig hebt?',
      'Ben jij je bewust van wie of wat jou de meeste energie kost? Hoe kun je daar vandaag anders mee omgaan? Of bij wegblijven?',
      'Hoe kun jij je energie beter verdelen?',
    ],
  },
  {
    name: 'Minder stress',
    questions: [
      'Wat helpt jou om stress te verminderen?',
      'Welke signalen geven aan dat jij gestresst bent?',
      'Hoe kun je in het moment tot rust komen?',
      'Wat zijn jouw beste stressmanagement technieken?',
      'Welke gedachten geven jou stress? Welke gedachten stellen je juist gerust?',
    ],
  },
  {
    name: 'Rust',
    questions: [
      'Waar word jij rustig van?',
      'Wat brengt jou in het hier en nu?',
      'Hoe creëer jij momenten van rust in jouw werkdag?',
      'Op welke plek ervaar jij innerlijke rust?',
      'Wat is jouw favoriete manier om te ontspannen?',
    ],
  },
  {
    name: 'Veerkracht',
    questions: [
      'Wat maakt jou sterk in moeilijke tijden?',
      'Hoe kom jij op adem na een zware (werk-)dag?',
      'Welke eigenschap helpt jou door uitdagingen heen?',
      'Hoe bouw jij aan jouw veerkracht?',
      'Wat geeft jou de moed om door te gaan?',
      'Wat helpt jou om je sterk en krachtig te voelen?',
    ],
  },
  {
    name: 'Veiligheid',
    questions: [
      'Waar voel jij je het meest veilig?',
      'Hoe creëer jij veiligheid voor jezelf?',
      'Wat heb jij nodig om je veilig te voelen (op het werk)?',
      'Wie of wat helpt jou om je veilig te voelen?',
      'Wie geeft jou een veilig gevoel?',
      'Wat is jouw veilige ruimte? Jouw plek waar je je kunt terugtrekken, op adem kunt komen, rust kunt vinden en kunt ontspannen?',
    ],
  },
  {
    name: 'Verbinding',
    questions: [
      'Op welke manier wil jij vandaag bewust verbinden met anderen? En met jezelf?',
      'Wat betekent verbinding voor jou?',
      "Hoe voel jij je verbonden met jouw collega's? Wat is hierin belangrijk voor jou?",
      'Hoe versterk jij jouw band met bewoners/cliënten?',
      'Wat helpt jou om echt contact te maken?',
    ],
  },
  {
    name: 'Vertrouwen',
    questions: [
      'Waar ben jij goed in? Vertrouw daarop!',
      'Op wie kun jij altijd rekenen?',
      "Hoe bouw jij vertrouwen op met bewoners/collega's/de mensen waarmee je werkt?",
      'Wat geeft jou (zelf-)vertrouwen in moeilijke situaties?',
      'Hoe versterk jij het vertrouwen binnen jouw team?',
    ],
  },
  {
    name: 'Vreugde & Plezier',
    questions: [
      'Wat brengt een glimlach op jouw gezicht?',
      'Hoe kun jij vandaag meer plezier ervaren? Bedenk er minimaal drie.',
      'Welk moment op het werk bracht jou vandaag vreugde?',
      'Hoe breng jij speelsheid in jouw dag?',
      'Waarvan schiet jij spontaan in de lach?',
      'Waar word jij blij van op je werk?',
      'Wanneer ga jij blij naar huis na een werkdag?',
    ],
  },
  {
    name: 'Zelfliefde',
    questions: [
      'Hoe kun jij meer liefde geven aan jezelf?',
      'Wat maakt jouw hart blij?',
      'Hoe spreek jij vriendelijk tegen jezelf?',
      'Welke eigenschap van jezelf waardeer je het meest?',
      'Hoe vier jij jouw successen?',
    ],
  },
  {
    name: 'Zelfzorg',
    questions: [
      'Hoe zorg jij vandaag voor jezelf? • Fysiek • Mentaal • Emotioneel • Energetisch',
      'Wat heb jij NU nodig?',
      'Welke zelfzorg rituelen heb jij?',
      'Hoe zorg jij vandaag voor je lichaam?',
      'Wat kun je vandaag doen om je batterij op te laden?',
    ],
  },
  {
    name: 'Hartzorg',
    questions: [
      'Hoe zorg jij vanuit jouw hart voor anderen?',
      'Wat raakt je hart in jouw werk?',
      'Hoe verbind jij Hoofd en Hart in jouw zorgverlening?',
      'Welk zorg- of contactmoment gaf jou vandaag veel warmte?',
      'Hoe breng jij liefde in jouw dagelijkse zorg/werk?',
      'Wat is voor jou het verschil tussen HOOFDzorg & HARTzorg?',
      'Wat zijn voor jou de 3 belangrijkste kenmerken van HARTzorg/werken vanuit je hart?',
      'Gun jij het advies/de zorg die je aan anderen geeft ook aan jezelf?',
    ],
  },
];

interface InspirationDeckProps {
  showThemes?: boolean;
}

export function InspirationDeck({ showThemes = true }: InspirationDeckProps) {
  const [flippedCard, setFlippedCard] = useState<number | null>(null);
  const [currentQuestion, setCurrentQuestion] = useState('');
  const { effectiveRole } = useAdminPreview();
  const isHoofdhart = effectiveRole === 'hoofdhartuser';

  const handleCardClick = (index: number) => {
    let question = '';
    if (showThemes) {
      const theme = CARDS[index];
      if (theme) {
        question =
          theme.questions[Math.floor(Math.random() * theme.questions.length)];
      }
    } else {
      const randomTheme = CARDS[Math.floor(Math.random() * CARDS.length)];
      question =
        randomTheme.questions[
          Math.floor(Math.random() * randomTheme.questions.length)
        ];
    }

    setCurrentQuestion(question);
    setFlippedCard(flippedCard === index ? null : index);
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 max-w-4xl mx-auto px-4 sm:px-0">
      {CARDS.map((theme, index) => (
        <Card
          key={index}
          className={cn(
            'aspect-[3/4] cursor-pointer perspective-1000 transition-transform duration-500 transform-style-preserve-3d shadow-xl hover:shadow-2xl rounded-3xl',
            flippedCard === index && 'rotate-y-180',
          )}
          onClick={() => handleCardClick(index)}
        >
          <div className="absolute inset-0 backface-hidden flex flex-col bg-green-50 shadow-lg rounded-3xl">
            <div className="flex-1 flex items-center justify-center">
              <img
                src={isHoofdhart ? '/images/hoofdnaarhart-logo.png' : '/images/logotrans.svg'}
                alt="Card Back"
                className="w-32 h-32 object-contain"
              />
            </div>
            {showThemes && (
              <p className="text-lg font-medium text-green-800 uppercase text-center pb-6">
                {theme.name}
              </p>
            )}
          </div>
          <div className="absolute inset-0 rotate-y-180 backface-hidden bg-green-50 flex flex-col items-center justify-between p-6 text-center rounded-3xl">
            <p className="text-lg font-serif text-green-800 flex-1 flex items-center">
              {flippedCard === index ? currentQuestion : ''}
            </p>
            <Button
              variant="outline"
              className="mt-4 border-green-600 text-green-600 hover:bg-green-50"
              onClick={(e) => {
                e.stopPropagation();
                setFlippedCard(null);
              }}
            >
              Terug
            </Button>
          </div>
        </Card>
      ))}
    </div>
  );
}
